import {
  quoteConfirmationReviewSchema,
  type QuoteConfirmationReview as Review,
} from './quoteReviewContract';

const QUOTE_PRESENTERS = new Set([
  'confirmation.presenters.acceptQuoteExact',
  'confirmation.presenters.acceptQuoteFloating',
  'confirmation.presenters.rejectQuote',
]);

/** Do not allow a headline to substitute for a missing or unreadable quote. */
export function parseQuoteConfirmationReview(
  params: Record<string, unknown>,
  presenterKey?: string
): { kind: 'absent' } | { kind: 'invalid' } | { kind: 'review'; review: Review } {
  if (!('quoteReview' in params)) {
    return QUOTE_PRESENTERS.has(presenterKey ?? '') ? { kind: 'invalid' } : { kind: 'absent' };
  }
  const parsed = quoteConfirmationReviewSchema.safeParse(params.quoteReview);
  if (!parsed.success) return { kind: 'invalid' };
  if (
    parsed.data.quote.status !== 'quote' ||
    parsed.data.quote.isDisputed ||
    !parsed.data.quote.allowedActions.includes(parsed.data.action)
  )
    return { kind: 'invalid' };
  try {
    new Intl.DateTimeFormat('en', { timeZone: parsed.data.quote.workshopTimezone });
  } catch {
    return { kind: 'invalid' };
  }
  return { kind: 'review', review: parsed.data };
}
